import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Fade } from 'react-bootstrap'

const SuccessMessage = props => {
  return (
    <Fade in={props.success}>
      <Alert className="Alert" onDismiss={props.dismiss} bsStyle="success">
        <p>Chapters reordered successfully!</p>
      </Alert>
    </Fade>
  )
}
SuccessMessage.propTypes = {
  success: PropTypes.bool.isRequired,
  dismiss: PropTypes.func.isRequired,
}

export default SuccessMessage
